/* EOFY Sale - tier filter chips (no network, pure show/hide) */
(function () {
  'use strict';

  function init(root) {
    var chips = root.querySelectorAll('[data-eofy-filter]');
    var tiers = root.querySelectorAll('[data-eofy-tier]');
    if (!chips.length || !tiers.length) return;

    function apply(value) {
      for (var i = 0; i < tiers.length; i++) {
        var show = value === 'all' || tiers[i].getAttribute('data-eofy-tier') === value;
        if (show) {
          tiers[i].removeAttribute('hidden');
        } else {
          tiers[i].setAttribute('hidden', '');
        }
      }
      for (var j = 0; j < chips.length; j++) {
        var active = chips[j].getAttribute('data-eofy-filter') === value;
        chips[j].classList.toggle('is-active', active);
        chips[j].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-eofy-filter]') : null;
      if (!chip || !root.contains(chip)) return;
      apply(chip.getAttribute('data-eofy-filter'));
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-eofy-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
